/* eslint-disable no-unused-vars */
/**
 * Provides a single instace of an AWS object, S3, etc
 * @file 
 * @author Benjamin Listwon
 */

import { S3Client } from '@aws-sdk/client-s3'
import { fromCognitoIdentityPool } from '@aws-sdk/credential-provider-cognito-identity'

// !!!!!!! TODO: This goes in .env !!!!!!!!
export const bucketName = process.env.VUE_APP_AWS_BUCKET_NAME
const bucketRegion = process.env.VUE_APP_AWS_BUCKET_REGION
const IdentityPoolId = process.env.VUE_APP_AWS_IDENTITY_POOL_ID

/**
 * An S3 client, credentialed via a Cognito identity pool.
 * AWS SDK v3 has no global Bucket param, so the bucket is passed per command
 * (see the upload module, which imports bucketName from here).
 * @constant
 * @type {object}
 */
const s3 = new S3Client({
	region: bucketRegion,
	credentials: fromCognitoIdentityPool({
		identityPoolId: IdentityPoolId,
		clientConfig: { region: bucketRegion },
	}),
})

export default s3